import * as React from 'react';

const SvgLine = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={345.333}
    height={337.333}
    viewBox="0 0 259 253"
    {...props}
  >
    <path d="M122.2 4c-28.9 7.3-39 13.5-42.7 26.5-3.9 13.2 3.4 28.8 16.3 35.2 5.2 2.5 6.7 2.8 16.2 2.7 8.3 0 13.2-.7 23.5-3.3 30.7-7.6 53.7-11.3 72-11.4 10.1 0 12.7.3 16.8 2.1 4 1.8 4.7 2.5 4.7 5 0 5.7-7.8 10.5-28.2 17.1-17.5 5.7-45.1 12.6-116.8 29.5-90.9 21.4-84.4 19.7-82.4 21.5.5.4 15.5 9.7 33.4 20.6 44.3 27.1 102.5 63 137.9 85.2 16.1 10.1 29.5 18.3 29.6 18.1.2-.2-2.3-12.9-5.6-28.3s-8.4-40.8-11.4-56.4c-3-15.6-5.6-28.5-5.7-28.6-.4-.3-26.9 6.3-27.4 6.8-.3.2 1.6 10.7 4.1 23.2 2.4 12.6 4.3 23 4.2 23.1-.1.1-9.6-5.6-21.2-12.8-11.5-7.2-30.4-18.7-42-25.7-11.6-7-21.1-13.1-21.3-13.5-.1-.5 11.8-3.9 26.5-7.6 14.7-3.7 30.2-7.7 34.3-8.9 4.1-1.2 17.4-4.4 29.5-7.2 26.1-5.9 36.3-8.8 50.5-14.1 22.4-8.4 33.5-15.8 38.7-26.2 2.3-4.6 2.5-5.8 2.1-14.6-.6-12.4-2.8-17.3-9.9-23-11-8.8-20.8-11.4-41.9-11.3-16.7.1-34.7 2.5-57.9 7.8-8.4 1.9-20.1 4.4-25.9 5.5-9.7 1.9-10.7 1.9-12.1.5-1.5-1.5-1.4-1.8.4-3.1 2.9-2.2 15.1-5.8 31.5-9.4 7.9-1.7 14.6-3.3 14.7-3.4.2-.2-3.5-5.8-8.3-12.4C138.4-1 140.1-.5 122.2 4z" />
  </svg>
);

export default SvgLine;
